/*
 * Event Details GraphQL specification
 * @module src/graphql/getInventoryRequestList
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

/**  Inventory Request list GraphQL API query */
export const GET_INVENTORY_REQUEST_FAVORITES = gql`
  query getInventoryFavorites {
    getInventoryFavorites {
      _id
      nameOfFavorite
      user
      serviceLevel
      externalId
      caseId
      comments {
        comment
        postTime
        commentType
        externalId
      }
      userDetails {
        sfId
        name
      }
      salesRep {
        id
        name
      }
      account {
        id
        name
      }
      shipTo {
        id
        name
      }
      lineItems {
        part {
          id
          name
        }
        lotNumber
        quantity
      }
    }
  }
`;
